import { render, staticRenderFns } from "./HighlightedOffers.vue?vue&type=template&id=c376b64c&scoped=true"
import script from "./HighlightedOffers.vue?vue&type=script&lang=js"
export * from "./HighlightedOffers.vue?vue&type=script&lang=js"
import style0 from "./HighlightedOffers.vue?vue&type=style&index=0&id=c376b64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c376b64c",
  null
  
)

export default component.exports